import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Icon, { IconType } from '../icon/icon';
import Link from '../link/link';
import './image.scss';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const Imagen = (props) => {
  const {
    className,
    src,
    alt,
  } = props;

  const [isImage, setIsImage] = useState(true);
  const [srcState, setSrcState] = useState();


  useEffect(() => {
    const newImage = new Image();
    setIsImage(true);
    newImage.onerror = () => {
      setIsImage(false);
    };
    newImage.src = src;
    setSrcState(src);
  }, [src]);

  return (
    <div className="d-inline">
      { isImage === true
      && (
        <div style={{ minWidth:'60px',display:'inline-block' }}>
        <div className="d-inline-block image__background mr-2">
          <img
            className={className}
            src={srcState}
            alt={alt}
          />
        </div>
        </div>
      )}
      { isImage === false && srcState !== '' && srcState.search('http') !== -1
      && (
          <OverlayTrigger
            placement={'top'}
            delay={{ show: 250, hide: 400 }}
            overlay={
              <Tooltip>
                {srcState}
              </Tooltip>
            }
          >
            <a href={srcState} className="mr-1" target="_blanck">
                Link file
            </a>
          </OverlayTrigger>
      )}
      { isImage === false && srcState !== '' && srcState.search('http') === -1
      && (
      <div className="mr-1">
        Local file: {srcState}
      </div>
      )}
    </div>
  );
};

Imagen.propTypes = {
  className: PropTypes.string,
  src: PropTypes.string,
  alt: PropTypes.string,
};

Imagen.defaultProps = {
  className: '',
  src: '',
  alt: '',
};

export default Imagen;
